const CONSENT_STORAGE_KEY = "qubiq_cookie_consent_v1";
const CONSENT_MAX_AGE_MS = 1000 * 60 * 60 * 24 * 180;

export const COOKIE_CATEGORIES = {
  necessary: true,
  analytics: false,
  marketing: false,
};

const normalizeBoolean = (value, fallback) =>
  typeof value === "boolean" ? value : fallback;

export const buildConsentRecord = (input = {}) => {
  const categories = {
    necessary: true,
    analytics: normalizeBoolean(input?.categories?.analytics, false),
    marketing: normalizeBoolean(input?.categories?.marketing, false),
  };

  return {
    version: 1,
    status: input?.status || "customized",
    updatedAt: input?.updatedAt || new Date().toISOString(),
    categories,
  };
};

export const readConsentRecord = () => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    const normalized = buildConsentRecord(parsed);
    const updatedAtMs = new Date(normalized.updatedAt).getTime();

    if (!Number.isFinite(updatedAtMs) || Date.now() - updatedAtMs > CONSENT_MAX_AGE_MS) {
      window.localStorage.removeItem(CONSENT_STORAGE_KEY);
      return null;
    }

    return normalized;
  } catch {
    return null;
  }
};

export const writeConsentRecord = (record) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(
    CONSENT_STORAGE_KEY,
    JSON.stringify(buildConsentRecord(record))
  );
};

export const clearConsentRecord = () => {
  if (typeof window === "undefined") return;
  window.localStorage.removeItem(CONSENT_STORAGE_KEY);
};

export const getDefaultConsentDraft = () => ({
  necessary: true,
  analytics: false,
  marketing: false,
});

export const getConsentStorageKey = () => CONSENT_STORAGE_KEY;
